import { IN_STOCK_ATTRIBUTE, IN_STOCK_VALUE, isInStockOnly } from '../lib/in-stock';
import { setRefinement } from '../lib/refinements';
import type { PlpFiltersState } from './use-plp-filters';

/**
 * The single seam for "In stock only" state. Today it is stored as a URL `refine`; to persist it per session
 * instead, change only this hook (and the loaders that read it) — consumers just use `{ enabled, setEnabled }`.
 */
export function useInStockFilter({ refines, applyRefines }: Pick<PlpFiltersState, 'refines' | 'applyRefines'>) {
    return {
        enabled: isInStockOnly(refines),
        setEnabled: (enabled: boolean) =>
            applyRefines(setRefinement(refines, IN_STOCK_ATTRIBUTE, enabled ? IN_STOCK_VALUE : null)),
    };
}
